import { ActionCreator } from "redux";
import { UpdateFlowAction, FlowState } from "./types";

export const updateFlow: ActionCreator<UpdateFlowAction> = (flow: FlowState) => ({
  type: "@@flow/UPDATE_FLOW",
  payload: flow
});
